import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import Image from 'next/image'
import contact from '@/styles/contact/index.module.scss'

import { Footer } from '@/components/organisms/Footer/Footer'
import { Contact } from '@/components/organisms/Contact/Contact'
export default function index () {
  return (
    <>
      <Menu />
      <div className={contact.container}>
        <Contact />
        <div className={contact.row}>
          <div className={contact.card_container}>
            <div className={contact.card_column}>
              <div className={contact.card2}>
                <div className={contact.icon_container}>
                  <Image
                    src='/img/contact/location.svg'
                    className={contact.logo2}
                    alt='Picture of the author '
                    width={82}
                    height={75}
                  />
                </div>
              </div>
              <div className={contact.description2}>
                <p className={contact.location}>Av. Convención Nte #1902 int 1 CP 20020 Aguascalientes, Ags.</p>
              </div>
            </div>
            <div className={contact.card_column}>
              <div className={contact.card}>
                <div className={contact.icon_container}>
                  <Image
                    src='/img/contact/consultation.svg'
                    className={contact.logo2}
                    alt='Picture of the author '
                    width={72}
                    height={65}
                  />
                </div>
              </div>
              <div className={contact.description}>
                <p className={contact.location2}>info@softbasys.com</p>
              </div>
            </div>
            <div className={contact.card_column}>
              <div className={contact.card}>
                <div className={contact.icon_container}>
                  <Image
                    src='/img/contact/call.svg'
                    className={contact.logo2}
                    alt='Picture of the author '
                    width={96}
                    height={96}
                  />
                </div>
              </div>
              <div className={contact.description}>
                <p className={contact.location2}>449 555 44 33</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}
